const swiperSideTitle = {
    swiperInstance: null,
    swiperInstanceNested: null,
    titles: [],
    init: () => {
        import('swiper/bundle').then(({Swiper}) => {

            let domEl = document.getElementById('js-swiper-side-title');

            if (domEl) {
                const params = getSwiperParams();
                swiperSideTitle.swiperInstance = new Swiper(domEl, params);
            }

            let nestedDomEls = document.querySelectorAll('.js-swiper-side-title-nested');
            if (nestedDomEls) {
                const params = getSwiperNestedParams();
                nestedDomEls.forEach(el => {
                    swiperSideTitle.swiperInstanceNested = new Swiper(el, params);
                })
            }
        })

        // let carouselContainer = jQuery("slide-background-carousel");
        // let fadeComplete = function(e) {
        //     carouselContainer.appendChild(arr[0]);
        // };
        // let carouselArray = jQuery("slide-background-carousel .slide-background");
        // for(var i=0; i < carouselArray.length; i++) {
        //     carouselArray[i].addEventListener("animationend", fadeComplete, false);
        // }

        // generate pagination with data-title
        jQuery('.js-swiper-side-title .swiper-side-title__slide').each(function(i) {
            swiperSideTitle.titles.push(jQuery(this).data('title'))
        });

        // manage pagination click as a mouseover
        setTimeout(function() {
            jQuery('.js-swiper-side-title .swiper-pagination-bullet').hover(function() {
                jQuery( this ).trigger( "click" );
            });
        }, 1000)

    }
};

const getSwiperParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: 'fade',
        speed: 500,
        resizeObserver: true,
        a11y: true,
        allowTouchMove: false, // preventing the touch slide
        watchSlidesProgress: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function(index, className) {
                return '<span class="' + className + '">' + swiperSideTitle.titles[index] + '</span>';
            }
        }
    }
}

const getSwiperNestedParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: 'fade',
        autoplay: {
            delay: 1500
        },
        speed: 750,
        resizeObserver: true,
        a11y: true,
        allowTouchMove: false, // preventing the touch slide
        watchSlidesProgress: true
    }
}

export default swiperSideTitle;